import React, {useEffect, useLayoutEffect, useState, useMemo, useReducer, useContext} from 'react'
import {useParams, useNavigate} from 'react-router-dom'
import OrderService from '../services/OrderService';
import {MaterialReactTable} from 'material-react-table';
import {Alert, AlertTitle, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, ListItemIcon, MenuItem, Typography} from '@mui/material';
import {Context} from '../index';
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import EntityList from "../components/EntityList";
import {toJS} from "mobx";
import MyButton from "../UI/MyButton/MyButton";
import DemandService from "../services/DemandService";
import MarkingCodeModal from "../components/MarkingCodeModal";
import PackageModal from "../components/PackageModal";
import PickupPackageModal from "../components/PickupPackageModal";
import ConsignmentConverter from '../utils/ConsignmentConverter';
import CorrectionNotice from '../components/CorrectionNotice';
import { printPdfSilent, downloadPdf } from '../utils/print-pdf';
import { READY_BUTTONS, STATES } from '../config';

const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));
// orderName может прийти пустым, если зеркало FLXDB отдало demand в окне
// пересоздания строки (half-written, customerOrder ещё NULL) - перечитываем,
// пока не появится.
const ORDER_NAME_REFETCH_ATTEMPTS = 3;
const ORDER_NAME_REFETCH_DELAY = 1000;
// 404 на первичной загрузке мог быть прочитан в том же окне пересоздания -
// один ретрай с задержкой перед тем, как признать demand удалённым.
const NOT_FOUND_RETRY_DELAY = 1500;

/**
 * выводить:
 * имя, дату, способ доставки, позиции
 * name, moment/created?, attributes.find(attribute => attribute.name == 'Способ доставки NEW').value, positions
 */

export default function DemandById() {
    const {store} = useContext(Context);
    const pagination = {
        pageSize: 100
    }
    // Use config for buttons and states (supports multi-instance deployment)
    const readyButtons = READY_BUTTONS;
    const STATES_MAP = STATES;
    const [demand, setDemand] = useState([]);
    const [loadError, setLoadError] = useState(null);
    const [orderUpdating, setOrderUpdating] = useState(false);
    const [rowSelection, setRowSelection] = useState({});
    let [barcodeParts, setBarcodeParts] = useState('');
    const [barcode, setBarcode] = useState({});
    const [, forceUpdate] = useReducer(x => x + 1, 0);
    const params = useParams();
    const [showPopup, setShowPopup] = useState(false);
    const [isWaitingButtonClicked, setIsWaitingButtonClicked] = useState(false);
    const [isCorrectButtonClicked, setIsCorrectButtonClicked] = useState(false);
    const [demandCorrectReason, setDemandCorrectReason] = useState("");
    const [demandWaitingReason, setDemandWaitingReason] = useState("");
    const [markingModalOpen, setMarkingModalOpen] = useState(false);
    const [currentMarkingProduct, setCurrentMarkingProduct] = useState(null);
    const [scannedConsignments, setScannedConsignments] = useState({});
    // PackageModal state: упаковщик после "Готово" вводит число мест
    const [packageModalOpen, setPackageModalOpen] = useState(false);
    const [packageDemandData, setPackageDemandData] = useState(null); // {id, name}
    // PickupPackageModal state: самовывоз без трека - кол-во мест без ТК-цепочки
    const [pickupModalOpen, setPickupModalOpen] = useState(false);
    // Ручной флоу (Почта России): показываем инфо-окно вместо печати PDF
    const [manualNoticeOpen, setManualNoticeOpen] = useState(false);
    // Защита от повторной печати: счётчик в localStorage за день. При count>=1
    // перед печатью показываем confirm-диалог "уже печатали N раз".
    const [confirmPrintOpen, setConfirmPrintOpen] = useState(false);
    const [pendingPrint, setPendingPrint] = useState(null); // {pdfBase64, safeName, count}
    const navigate = useNavigate();
    const columns = useMemo(
        () => [
            {
                accessorKey: 'image',
                header: 'Изображение',
                size: 200,
                Cell: ({cell}) => (
                    <img
                        alt="No image"
                        src={cell.getValue()}/>
                )
            },
            {
                accessorKey: 'article',
                header: 'Артикул',
                size: 200
            },
            {
                accessorKey: 'name',
                header: 'Наименование',
                size: 200,
                Cell: ({ row }) => {
                    const item = row.original;
                    const hasConsignment = item.type === 'consignment' && item.consignmentLabel;

                    return (
                        <div>
                            <div>{item.name}</div>
                            {hasConsignment && (
                                <div style={{
                                    display: 'inline-block',
                                    marginTop: '4px',
                                    padding: '2px 8px',
                                    fontSize: '11px',
                                    fontWeight: 'bold',
                                    color: '#1565c0',
                                    backgroundColor: '#e3f2fd',
                                    border: '1px solid #90caf9',
                                    borderRadius: '4px'
                                }}>
                                    Серия: {item.consignmentLabel}
                                </div>
                            )}
                        </div>
                    );
                }
            },
            {
                accessorKey: 'quantity',
                header: 'Количество',
                size: 200,
                Cell: ({cell}) => (
                    <span style={{fontSize: '20px'}}>
                        {cell.getValue()}
                    </span>
                )
            }
        ],
        [],
    );

    useEffect(() => {
        getDemandById(params.id);
        uploadSelectedRowsFromServer();

    }, [params.id])

    async function uploadSelectedRowsFromServer() {
        try {
            const response = await store.checkEntitiesInWork();

            const orderInStore = toJS(store.entitiesInWork);
            const rowsToUpdate = orderInStore.find(item => item.id === params.id).selectedPositions;

            console.log('order in store', rowsToUpdate)

            setRowSelection({...rowsToUpdate});

        } catch (e) {
            console.log(e);
        }
    }


    useEffect(() => {
        console.log(rowSelection);
        const orderInStoree = updateSelectedPositions();

    }, [rowSelection])

    async function updateSelectedPositions() {
        const updateRows = Object.assign({}, rowSelection);
        console.log('updateRows', updateRows);
        let serverResToUpdateSelectedPositions;
        if (Object.keys(updateRows).length > 0) {
            await DemandService.updateSelectedPositions(params.id, {updateRows});
        }

        return serverResToUpdateSelectedPositions;
    }

    useEffect(() => {
        function handleKeyDown(e) {
            // Игнорируем события когда модальное окно маркировки открыто
            if (markingModalOpen) {
                return;
            }
            
            if (e.key === 'Enter') {
                setBarcode({value: parseScannedInput(barcodeParts)});
                setBarcodeParts('');
                return;
            }

            let newBarcode = barcodeParts.concat(e.key);
            setBarcodeParts(newBarcode);
        }

        document.addEventListener('keydown', handleKeyDown);

        return function cleanup() {
            document.removeEventListener('keydown', handleKeyDown);
        }
    }, [barcodeParts, markingModalOpen]);

    useEffect(() => {
        if (demand.length !== 0) {
            console.log('demand', demand);

            // Сначала ищем среди обычных штрихкодов
            let scannedProduct = demand.positions.find(position => position.barcode === barcode.value);

            // Если не найдено - ищем среди штрихкодов серий (consignmentBarcode)
            if (!scannedProduct) {
                scannedProduct = demand.positions.find(position =>
                    position.consignmentBarcode === barcode.value &&
                    position.type === 'consignment'
                );
            }

            console.log(barcode.value);
            console.log(scannedProduct);

            if (scannedProduct) {
                setBarcodeParts('');

                // Проверка на повторное сканирование серии
                if (scannedProduct.type === 'consignment' && scannedConsignments[scannedProduct.id]) {
                    setShowPopup(true);
                    return;
                }

                // Отмечаем серию как отсканированную
                if (scannedProduct.type === 'consignment') {
                    setScannedConsignments(prev => ({
                        ...prev,
                        [scannedProduct.id]: true
                    }));
                }

                // Проверка на маркированный товар
                if (scannedProduct.isMarked) {
                    console.log('Marked product detected:', scannedProduct);
                    setCurrentMarkingProduct(scannedProduct);
                    setMarkingModalOpen(true);
                    return;
                }

                // Обычная логика для немаркированных товаров. Один и тот же
                // товар может идти отдельной позицией и компонентом комплекта:
                // строк две, штрихкод один - отмечаем все строки с этим
                // штрихкодом, иначе вторая не отметится сканом.
                const scannedRows = demand.positions.filter(position => position.barcode === barcode.value);
                const rowsToSelect = scannedRows.length > 0 ? scannedRows : [scannedProduct];
                const selectedRow = Object.assign(rowSelection);
                for (const rowToSelect of rowsToSelect) {
                    selectedRow[rowToSelect.id] = true;
                }
                setRowSelection((selectedRow) => (selectedRow));
                console.log('selected row', selectedRow);
            } else {
                setBarcodeParts('');
                setShowPopup(true);
                return;
            }
        }
        forceUpdate();
    }, [barcode])

    async function getDemandById(id) {
        let demandIsTaken = false;
        let notFoundRetries = 0;
        while (!demandIsTaken) {
            try {
                const response = await DemandService.getDemandById(id);
                console.log(response);

                setDemand(response.data);
                setLoadError(null);
                demandIsTaken = true;

                // orderName пустой -> зеркало FLXDB, видимо, отдало demand в окне
                // пересоздания строки (half-written, customerOrder ещё NULL).
                // Перечитываем пару раз, пока не появится.
                if (!response.data?.orderName) {
                    setOrderUpdating(true);
                    for (let i = 0; i < ORDER_NAME_REFETCH_ATTEMPTS; i++) {
                        await sleep(ORDER_NAME_REFETCH_DELAY);
                        try {
                            const retry = await DemandService.getDemandById(id);
                            setDemand(retry.data);
                            if (retry.data?.orderName) break;
                        } catch (retryErr) {
                            console.log('orderName refetch failed:', retryErr);
                            break;
                        }
                    }
                    setOrderUpdating(false);
                }

            } catch (e) {
                console.log(e);

                if (e.response?.status === 410) {
                    const errorData = e.response.data;
                    alert(`${errorData.message || 'Отгрузка уже завершена'}`);

                    navigate('/start');
                    return;
                }

                if (e.response?.status === 404) {
                    // demand не существует в БД (например, удалён в МС и
                    // пересоздан с новым UUID). Чистим из Redis, чтобы при
                    // следующем "Новый заказ" find(current:true) его не нашёл.
                    // Один ретрай с задержкой - могли попасть в окно пересоздания.
                    if (notFoundRetries < 1) {
                        notFoundRetries++;
                        await sleep(NOT_FOUND_RETRY_DELAY);
                        continue;
                    }
                    try {
                        await DemandService.removeDemandFromWork(id, store.user.position);
                    } catch (cleanupErr) {
                        console.log('removeDemandFromWork failed:', cleanupErr);
                    }
                    const serverMessage = e.response?.data?.message || 'Отгрузка не найдена';
                    alert(`${serverMessage}\n\nВозьмите новый заказ.`);
                    navigate('/start');
                    return;
                }

                // Любые другие ошибки (сеть, 500, ...) - показываем сообщение
                // вместо пустого экрана и выходим из while.
                const serverMessage = e.response?.data?.message;
                setLoadError(serverMessage || e.message || 'Не удалось загрузить отгрузку');
                demandIsTaken = true;
            }
        }
    }

    function parseScannedInput(input) {
        const matches = input.match(/Alt(\d+)/g);
        if (!matches) return input;

        return matches.map((code) => {
            const num = code.replace("Alt", "");
            return String.fromCharCode(parseInt(num));
        }).join('');
    }

    const handleSendToCorrect = async () => {
        if (!demandCorrectReason.trim()) {
            alert('Укажите причину корректировки');
            return;
        }
        try {
            const result = await DemandService.changeStatus(params.id, 'Корректировка', demandCorrectReason);
            console.log(result);
            console.log(store.user.id);
            const serverRes = await DemandService.moveDemandToWaitingList(params.id, 'correct', demandCorrectReason);
            alert(`Отгрузка ${demand.name} успешно отправлена на корректировку!`)
            navigate('/start')

        } catch (error) {
            alert(`Ошибка! Что-то пошло не так...\n${error.message}`)
        }
    };

    const handleToWaitingList = async () => {
        const serverRes = await DemandService.moveDemandToWaitingList(params.id, 'waiting', demandWaitingReason);
        alert(`Отгрузка ${demand.name} успешно отправлена в лист ожидания!`)
        navigate('/start');
    };

    // Обработчик завершения маркировки
    const handleMarkingComplete = (product) => {
        console.log('handleMarkingComplete called for product:', product.article);
        // Автоматически отметить позицию как выполненную
        const selectedRow = Object.assign(rowSelection, {[product.id]: true});
        setRowSelection(selectedRow);

        // Закрыть модальное окно
        setMarkingModalOpen(false);
        setCurrentMarkingProduct(null);

        console.log(`Marking completed for product ${product.article}`);
    };

    // Кастомный обработчик выделения строк
    const handleRowSelectionChange = (updater) => {
        const newSelection = typeof updater === 'function' ? updater(rowSelection) : updater;
        setRowSelection(newSelection);

        const selectedCount = Object.keys(newSelection).length;

        // Обрабатываем ТОЛЬКО когда выбрана ровно ОДНА строка
        if (selectedCount === 1) {
            const selectedId = Object.keys(newSelection)[0];
            const selectedProduct = demand.positions.find(position =>
                position.id === selectedId
            );

            // Если это маркированный товар - открываем модальное окно
            if (selectedProduct && selectedProduct.isMarked) {
                console.log('Marked product selected via checkbox:', selectedProduct);
                setCurrentMarkingProduct(selectedProduct);
                setMarkingModalOpen(true);
            }
        }

        // Если selectedCount === 0 или selectedCount > 1 - ничего дополнительно не делаем
        console.log('Row selection updated:', selectedCount, 'rows selected');
    };

    // Финализация упаковки: убираем demand из работы и уходим на /start.
    // Используется и в авто-флоу (после silent print), и в ручном (после OK
    // в инфо-окне Почты России).
    const finalizeAndLeave = async () => {
        try {
            await DemandService.removeDemandFromWork(params.id, store.user.position);
        } catch (e) {
            console.warn('removeDemandFromWork failed after packaging', e);
        }
        navigate('/start');
    };

    // Callback успеха упаковки: silent print -> fallback download -> cleanup + leave.
    // Для ручного флоу (manualPackage=true, Почта России) PDF не приходит -
    // показываем инфо-окно, финализация делается по кнопке "Понятно".
    // Перед печатью проверяем локальный счётчик: если этот заказ уже печатали
    // сегодня (count>=1) - спрашиваем подтверждение. Защита от зависшего
    // диалога печати / повторного клика, который дубль-засоряет принтер
    // (прецедент 90015, 19.08.2026: "бесконечная печать, ни таймаута ни ошибки").
    const handlePackageSuccess = async (data) => {
        if (data?.manualPackage) {
            setPackageModalOpen(false);
            setPackageDemandData(null);
            setManualNoticeOpen(true);
            return;
        }
        const { pdfBase64 } = data;
        const safeName = (packageDemandData?.name || 'unknown').replace(/[^\w-]+/g, '_');
        if (pdfBase64) {
            const demandId = packageDemandData?.id;
            const count = getPrintCountToday(demandId);
            if (count >= 1) {
                // Уже печатали сегодня - отложить cleanup до ответа в диалоге.
                setPendingPrint({ pdfBase64, safeName, count });
                setConfirmPrintOpen(true);
                return;
            }
            await doPrint(pdfBase64, safeName, demandId);
        }
        // Cleanup модалки
        setPackageModalOpen(false);
        setPackageDemandData(null);
        await finalizeAndLeave();
    };

    // Callback успеха упаковки самовывоза: cleanup + выход, без печати
    // (PDF не возвращается). Убираем demand из работы и на /start.
    const handlePickupSuccess = async () => {
        setPickupModalOpen(false);
        setPackageDemandData(null);
        await finalizeAndLeave();
    };

    // Подтверждение повторной печати из диалога.
    const handleConfirmReprint = async () => {
        const pending = pendingPrint;
        setConfirmPrintOpen(false);
        setPendingPrint(null);
        if (pending) {
            await doPrint(pending.pdfBase64, pending.safeName, packageDemandData?.id);
        }
        setPackageModalOpen(false);
        setPackageDemandData(null);
        await finalizeAndLeave();
    };

    // Отмена повторной печати: cleanup без печати (заказ всё равно упакован
    // на бэке, /package уже отработал). Если печать реально нужна - юзер
    // может зайти в заказ повторно или попросить менеджера.
    const handleCancelReprint = async () => {
        setConfirmPrintOpen(false);
        setPendingPrint(null);
        setPackageModalOpen(false);
        setPackageDemandData(null);
        await finalizeAndLeave();
    };

    // Локальный счётчик печатей за день. localStorage ключ
    // printed:{demandId}:{YYYY-MM-DD} - авто-сброс при смене даты.
    // try/catch: localStorage может быть недоступен (privacy режим, квота).
    const getPrintCountToday = (demandId) => {
        if (!demandId) return 0;
        try {
            const key = `printed:${demandId}:${new Date().toISOString().slice(0, 10)}`;
            return Number(localStorage.getItem(key) || 0);
        } catch (_) {
            return 0;
        }
    };

    const incrementPrintCount = (demandId) => {
        if (!demandId) return;
        try {
            const key = `printed:${demandId}:${new Date().toISOString().slice(0, 10)}`;
            const cur = Number(localStorage.getItem(key) || 0);
            localStorage.setItem(key, String(cur + 1));
        } catch (_) {
            // localStorage недоступен - молча пропускаем, счётчик не критичен
        }
    };

    // Печать с инкрементом счётчика и fallback на download при ошибке.
    const doPrint = async (pdfBase64, safeName, demandId) => {
        try {
            await printPdfSilent(pdfBase64);
            incrementPrintCount(demandId);
        } catch (e) {
            console.warn('Silent print failed, falling back to download', e);
            try { downloadPdf(pdfBase64, `demand-${safeName}.pdf`); } catch (_) {}
        }
    };


    return (
        <div>
            {loadError
                ?
                <Alert severity="error" sx={{ m: 2 }}>
                    <AlertTitle>Ошибка загрузки отгрузки</AlertTitle>
                    {loadError}
                </Alert>
                : demand?.positions
                ?
                <>
                {/* Был ли заказ на корректировке - по записям [КОРРЕКТИРОВКА ...]
                    в description. Видно до начала упаковки, закрытие - на просмотр. */}
                <CorrectionNotice description={demand.description} />
                <MaterialReactTable columns={columns} data={demand.positions}
                                    enableRowSelection
                                    enableSelectAll={false}
                                    onRowSelectionChange={handleRowSelectionChange}
                                    initialState={{pagination}}
                                    getRowId={(originalRow)=> originalRow.id}
                                    state={{rowSelection}}
                                    renderTopToolbarCustomActions={({table}) => {
                                        const handleCollectOrder = async () => {
                                            try {
                                                const result = await DemandService.changeStatus(params.id, STATES_MAP.get(store.user.position));
                                                console.log(result);

                                                // Для упаковщика - открыть PackageModal
                                                // (changeStatus уже перевёл demand в "Упаковано");
                                                // removeDemandFromWork + navigate делаются в onSuccess после silent print.
                                                if (store.positionKey === 'packer' && !demand?.skipPackages) {
                                                    setPackageDemandData({ id: params.id, name: demand?.name });
                                                    setPackageModalOpen(true);
                                                    return;
                                                }

                                                // Самовывоз без трек-номера (demand.skipPackages):
                                                // ТК-цепочка не нужна, но кол-во мест спросим -
                                                // оно уйдёт в description отгрузки + Bitrix24
                                                // через /pickup-package. Без PDF и печати.
                                                if (store.positionKey === 'packer' && demand?.skipPackages) {
                                                    setPackageDemandData({ id: params.id, name: demand?.name });
                                                    setPickupModalOpen(true);
                                                    return;
                                                }

                                                const removeOrderFromWork = await DemandService.removeDemandFromWork(params.id, store.user.position);
                                                console.log(removeOrderFromWork)
                                                alert(`Отгрузка ${demand.name} переведена на статус ${STATES_MAP.get(store.user.position)}!`)
                                                navigate('/start')
                                            } catch (error) {
                                                alert(`Ошибка! Что-то пошло не так...\n${error.message}`)
                                            }
                                        };

                                        return (
                                            <div>
                                                <div style={{
                                                    display: "flex",
                                                    justifyContent: "flex-start",
                                                    marginTop: 9,
                                                    marginLeft: 35,
                                                    whiteSpace: 'pre-line'
                                                }}>Комментарий: <b>{demand.description}</b></div>
                                                {demand.extraComment && (
                                                    <div style={{
                                                        display: "flex",
                                                        justifyContent: "flex-start",
                                                        marginTop: 9,
                                                        marginLeft: 35
                                                    }}>Комментарий к заказу: <b>{demand.extraComment}</b></div>
                                                )}
                                                <div style={{display: 'flex', gap: '0.5rem'}}>
                                                    <Button
                                                        color="success"
                                                        disabled={!table.getIsAllRowsSelected()}
                                                        onClick={handleCollectOrder}
                                                        variant="contained"
                                                    >
                                                        {readyButtons[store.user.position]}
                                                    </Button>
                                                    <Button
                                                        color="error"
                                                        onClick={() => setIsCorrectButtonClicked(true)}
                                                        variant="contained"
                                                    >
                                                        КОРРЕКТИРОВКА
                                                    </Button>
                                                    <Button
                                                        color="primary"
                                                        onClick={() => setIsWaitingButtonClicked(true)}
                                                        variant="contained"
                                                    >
                                                        В ожидание
                                                    </Button>
                                                </div>
                                                <div style={{display: "flex"}}>
                                                    <div style={{
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        marginTop: 9,
                                                        marginLeft: 35
                                                    }}>Отгрузка: <b>{demand.name}</b></div>
                                                    <div style={{
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        marginTop: 9,
                                                        marginLeft: 35
                                                    }}>Способ доставки: <b>{demand.delivery}</b></div>
                                                    <div style={{
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        marginTop: 9,
                                                        marginLeft: 35
                                                    }}>Заказ: <b>{orderUpdating ? 'обновляется...' : (demand.orderName || '—')}</b></div>
                                                </div>
                                            </div>
                                        );
                                    }}
                />
                </>
                :
                <Box sx={{ p: 4, textAlign: 'center' }}>
                    <Typography>Загрузка отгрузки...</Typography>
                </Box>}
            <Popup open={showPopup} onClose={() => setShowPopup(false)}><h4> Неверный штрихкод! </h4></Popup>
            <Popup open={isCorrectButtonClicked} onClose={() => setIsCorrectButtonClicked(false)}>
                <h2> Укажите причину корректировки </h2>
                <input
                    onChange={(e) => {
                        setDemandCorrectReason(e.target.value)
                    }}
                    name={"correct_reason"}
                    value={demandCorrectReason}
                    type="text"
                    placeholder='причина корректировки'
                />
                <small style={{display: 'block', color: '#888', marginTop: 4}}>
                    Поле обязательно для корректировки
                </small>
                <MyButton
                    disabled={!demandCorrectReason.trim()}
                    onClick={() => handleSendToCorrect()}
                >
                    Отправить
                </MyButton>
            </Popup>
            <Popup open={isWaitingButtonClicked} onClose={() => setIsWaitingButtonClicked(false)}>
                <h2> Укажите причину ожидания </h2>
                <input
                    onChange={(e) => {
                        setDemandWaitingReason(e.target.value)
                    }}
                    name={"waiting_reason"}
                    value={demandWaitingReason}
                    type="text"
                    placeholder='причина ожидания'
                />
                <MyButton onClick={() => handleToWaitingList()}> Отправить </MyButton>
            </Popup>
            
            {/* Модальное окно для сканирования кодов маркировки */}
            <MarkingCodeModal
                isOpen={markingModalOpen}
                onClose={() => {
                    console.log('MarkingCodeModal onClose called!');
                    setMarkingModalOpen(false);
                    setCurrentMarkingProduct(null);
                }}
                demand={demand}
                product={currentMarkingProduct}
                onComplete={handleMarkingComplete}
            />

            {/* PackageModal: упаковщик вводит число мест после "Готово" */}
            <PackageModal
                open={packageModalOpen}
                onClose={() => {
                    setPackageModalOpen(false);
                    setPackageDemandData(null);
                }}
                demandId={packageDemandData?.id}
                demandName={packageDemandData?.name}
                onSuccess={handlePackageSuccess}
            />

            {/* PickupPackageModal: самовывоз / оформление доставки клиентом -
                кол-во мест в комментарий, без ТК */}
            <PickupPackageModal
                open={pickupModalOpen}
                onClose={() => {
                    setPickupModalOpen(false);
                    setPackageDemandData(null);
                }}
                demandId={packageDemandData?.id}
                demandName={packageDemandData?.name}
                deliveryMethod={demand?.delivery}
                onSuccess={handlePickupSuccess}
            />

            {/* Ручной флоу (Почта России): нет PDF, оператор меняет число мест сам */}
            <Dialog open={manualNoticeOpen} maxWidth="xs" fullWidth>
                <DialogTitle>Внимание</DialogTitle>
                <DialogContent>
                    <Typography>
                        Почта России не поддерживается в автоматическом режиме.
                        Обязательно укажите количество мест вручную.
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button
                        variant="contained"
                        onClick={async () => {
                            setManualNoticeOpen(false);
                            await finalizeAndLeave();
                        }}
                    >
                        Понятно
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Защита от повторной печати: счётчик в localStorage показал count>=1.
                Заказ уже распечатан сегодня - спрашиваем подтверждения, чтобы
                не плодить копии при зависшем диалоге печати. */}
            <Dialog open={confirmPrintOpen} maxWidth="xs" fullWidth>
                <DialogTitle>Повторная печать</DialogTitle>
                <DialogContent>
                    <Typography>
                        Этот заказ уже печатали сегодня ({pendingPrint?.count ?? 0} раз).
                        Печатать ещё раз?
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCancelReprint} color="inherit">
                        Отмена
                    </Button>
                    <Button onClick={handleConfirmReprint} variant="contained" color="primary">
                        Печатать
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}
